'use client';

import { useOperationCosts } from '@/contexts/ai/hooks/useOperationCost';

/**
 * Get image generation cost per image.
 *
 * Sourced from ACCOUNTS (#79) via the estimate seam so the shown portrait cost
 * equals the real charge — no portal-local sell-rate. Uses the dedicated
 * character_portrait op; falls back to its flat registry hold while loading / on
 * failure.
 */
export function useImageCost(): { cost: number; loading: boolean } {
  const { costs, loading } = useOperationCosts([{ opType: 'character_portrait', imageCount: 1 }]);
  return { cost: costs[0] ?? 0, loading };
}
